import cslx from 'clsx';

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'error';
  size?: 'small' | 'regular';
}

const stylesByVariant = {
  primary: 'bg-primary-yellow border-primary-yellow text-primary-black',
  secondary: 'bg-primary-white border-primary-green text-primary-green',
  error: 'bg-red-200 border-red-200 text-primary-white',
};

const baseStylesBySize = {
  small: 'text-1-2 border rounded-4-0 px-1-0 py-0-5 leading-1-0 font-bd',
  regular: 'text-body1 border rounded-8-0 px-2-0 py-1-0 leading-1-0 font-bd',
};

const Button: React.FC<ButtonProps> = (props) => {
  const {
    children,
    variant = 'primary',
    size = 'regular',
    disabled = false,
    type,
    className,
    ...otherProps
  } = props;

  return (
    <button
      disabled={disabled}
      className={cslx(
        className,
        stylesByVariant[variant],
        baseStylesBySize[size],
        disabled && 'opacity-50',
      )}
      type={type}
      {...otherProps}
    >
      {children}
    </button>
  );
};

export default Button;
